import { useState, useEffect } from "react";
import { format } from "date-fns";
import { it } from "date-fns/locale";
import { Clock } from "lucide-react";

export const LiveClock = ({ className = "" }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="live-clock">
      <Clock className="w-4 h-4" />
      <span className="font-medium">
        {format(currentTime, "EEEE d MMMM yyyy", { locale: it })}
      </span>
      <span className="text-sky-500 font-bold">
        {format(currentTime, "HH:mm:ss")}
      </span>
    </div>
  );
};
